"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gzip = gzip;
exports.ungzip = ungzip;
exports.isNativeGzipSupported = isNativeGzipSupported;
var worker_1 = require("../common/worker");
var gzipWorkerCode = "\n    self.onmessage = async (e) => {\n      try {\n        const blob = e.data.blob;\n        const cs = e.data.compressed ? new DecompressionStream(e.data.type) : new CompressionStream(e.data.type);\n        const compressedStream = blob.stream().pipeThrough(cs);\n        const compressedBlob = await new Response(compressedStream).blob();\n        self.postMessage({ data: compressedBlob });\n      } catch (err) {\n        self.postMessage({ error: err });\n      }\n    };\n  ";
var sharedPool = null;
function getWorkerPool() {
    if (!isNativeGzipSupported()) {
        throw new Error("CompressionStream not supported");
    }
    if (!sharedPool)
        sharedPool = (0, worker_1.createWorkerPoolFromCode)(gzipWorkerCode, 6);
    return sharedPool;
}
function gzip(blob) {
    return getWorkerPool().process({
        blob: blob,
        type: "gzip",
        compressed: false,
    });
}
function ungzip(blob) {
    return getWorkerPool().process({
        blob: blob,
        type: "gzip",
        compressed: true,
    });
}
function isNativeGzipSupported() {
    return "CompressionStream" in self;
}
